import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

var outerFormStyle =
{
  backgroundColor: '#FFFFFF',
  padding:10,
  maxWidth:"90vw",
}

const msgStyle = {
  fontSize:14,
}

const okBtnStyle = {
  width:50,
  margin:"auto",
}

export class MessageModal extends React.Component {
   constructor(props)
   {
      super(props);
   }

   render()

   {

    return (
      <div style={outerFormStyle}>
        <h1>{this.props.heading}</h1>
        {this.props.msg.split("\n").map((line, i)=>{return <p key={i} style={msgStyle}>{line}</p>})}
        <button style={okBtnStyle} onClick={this.props.popModal}>ok</button>
            
      </div>
      );

    }
}

MessageModal.propTypes = {
  heading: PropTypes.string,
  msg: PropTypes.string,
  popModal: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./js/MessageModal.jsx